import React, { Component } from 'react'
import T from 'i18n-react'
import CSSModules from 'react-css-modules'

import SpecItem from 'components/custom/SpecItem/index'
import ListItemSpec from 'containers/Project/ListItemSpec/index'

class ItemComponent extends Component {
  render() {
    const {
      header,
      items,
    } = this.props

    return (
      <div>
        <h5>{ header }</h5>
        { items }
      </div>
    )
  }
}

export default ItemComponent
